import React, { ReactNode, FC } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from '../helpers/queryClient';

interface Props {
  children: ReactNode;
  devTools?: boolean;
  client?: QueryClient;
}
export const QueryClientWrapper: FC<Props> = ({
  children,
  devTools = true,
  client = queryClient,
}) => (
  <QueryClientProvider client={client}>
    {children}
    {devTools && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);
